import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'amos-p',
  template: require('./p.component.html'),
  styles: [require('./p.component.css')]
})
export class PComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/micro-components/p-component/p.component.ts